import { Injectable } from '@angular/core';
import { FormFactoryModel } from '@app/shared/common';

@Injectable({
  providedIn: 'root',
})
export class GenerateReportFieldsService {
  /**
   * * Main
   */
  mainFields: FormFactoryModel[] = [
    {
      colSize: 'col-12 ',
      group: [
        {
          controlType: 'dropdown',
          options: {
            label: 'Izveštaj',
            type: 'text',
            formControlName: 'report_type',
            value: '',
            optionValue: 'value',
            optionLabel: 'title',
            dropdownOptions: [
              {
                title: 'Po datumu',
                value: 'date',
              },
              {
                title: 'Do sada',
                value: 'until_now',
              },
            ],
          },
        },
        {
          controlType: 'datepicker',
          options: {
            label: 'Od datuma',
            type: 'text',
            formControlName: 'date_from',
          },
        },
        {
          controlType: 'datepicker',
          options: {
            label: 'Do datuma',
            type: 'text',
            formControlName: 'date_to',
          },
        },
      ],
    },
  ];
}
